import * as React from 'react';
import Button from '../common/Button/Button';
import Modal from '../common/Modal/Modal';
import config from '../../../config';
import { useAppSelector } from '../../store/app';
import { isLocalContainer } from '../../modules/project.utils';
import { APP_MODE } from '../../reducers/studio/ui';
import Styles from './create-redirect-modal.module.scss';
import InfoIcon from '../../assets/icons/v2design/basics/info.svg';

export function CreateRedirectModal() {
    const isPrevStackbitDomain = window.location.hostname === new URL(config.stackbit_app.base_url).hostname;
    const isLocalDev = useAppSelector((state) => isLocalContainer(state.studio.project) || window.location.href.includes('local'));
    const initialProjectLoading = useAppSelector((state) => state.studio.initialProjectLoading);
    // preview mode might be set later then global modal is rendered, hence relay on previewToken as well
    const isPreviewMode = useAppSelector((state) => state.studio.ui.appMode === APP_MODE.PREVIEW || window.location.href.includes('previewToken'));

    const isLocal = config.env === 'local';
    if (!isPrevStackbitDomain || isLocal || isLocalDev || isPreviewMode || initialProjectLoading) {
        return null;
    }
    return (
        // @ts-expect-error TS(2322): Type '{ children: Element; fullScreen: true; useBa... Remove this comment to see the full error message
        <Modal
            fullScreen
            useBaseModal
            icon={InfoIcon}
            size={'large'}
            addDim
            showCloseButton={false}
            onBeforeClose={() => false}
            Title="Netlify Create is live"
            Footer={
                <>
                    <Button
                        buttonType="primary"
                        onClick={() => {
                            if (isPrevStackbitDomain) {
                                const url = window.location.href.replace(window.location.hostname, new URL(config.app.base_url).hostname);
                                window.location.assign(url);
                            }
                        }}
                    >
                        Go to Netlify Create
                    </Button>
                </>
            }
        >
            <div className={Styles['content']}>
                <p>Stackbit is now Netlify Create.</p>
            </div>
        </Modal>
    );
}
